import type { Position } from 'geojson';

export const TEST_ID = 'mapBox';

export const MAP_CANVAS_TEST_ID = 'mapCanvas';

export { MAP_LAYER } from 'components/Map/constants';

export const DEFAULT_ZOOM = 3.5;

export const DEFAULT_CENTER: Position = [-98.5795, 39.8283];

export const MAP_STYLE = 'mapbox://styles/mapbox/standard-satellite';

export { ON_CLICK_MARKER_EVENT } from 'components/MapBox/hooks/useMarkers/constants';
